<div class='container-lg pt-4'>
  <div class='mb-2'>
    <mat-form-field class='w-100' *ngIf='userRole==="superuser" && options[0]'>
      <mat-label>View as Organization</mat-label>
      <input type='text' matInput [formControl]='orgControl' [matAutocomplete]='auto'>
      <mat-autocomplete (optionSelected)='changeViewingOrg($event)'  #auto='matAutocomplete' [displayWith]='orgDisplayFn'>
        <mat-option *ngFor='let org of filteredOptions | async' [value]='org'>
          {{org.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class='w-100'>
      <mat-label>Search locations by name or address</mat-label>
      <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

      <input matInput type='text' (keyup)='updateSearchTerm($event)'>
    </mat-form-field>

  </div>
  <div class='list-container mb-3' [hidden]='loaded' *ngFor='let i of [].constructor(20)'>
    <ngx-skeleton-loader count='1' [theme]="{
          'width': '25%'
        }"></ngx-skeleton-loader>
    <hr>
    <div class='row mb-3'>
      <div class='col-2'>

        <div class='text-capitalize font-16'>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </div>
      </div>
      <div class='col-sm-6 col-xl-3 dropdown-container'>
        <div class='font-16'>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>

        </div>
      </div>
      <div class='col-sm-6 col-xl-3 dropdown-container'>

        <div class='text-capitalize font-16'>

          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </div>


      </div>
    </div>

  </div>


  <div (click)='navigateToLocation(place)'
       [hidden]='!loaded || !place.name || (place.lat === 0 && place.lng === 0) || place.numberOfTests === 0'
       *ngFor='let place of locationsToDisplay' class='list-container mb-3'>
    <div class='pointer-cursor'>
      <div class='d-flex justify-content-between'>
        <div class='text-primary font-weight-bold'>
          <i class='fas fa-map-marker-alt mx-1'></i>
          {{place.formatted_address || place.name}}
        </div>
      </div>
      <hr>
      <div class='row mb-3'>
        <div class='col-6 col-md-4 col-xl-3'>
          <small>NUMBER OF TESTS</small>

          <div class='text-capitalize font-16'>{{place.numberOfTests}}</div>
        </div>
        <div class='col-6 col-md-4 col-xl-3'>
          <small>NUMBER OF WATER SOURCES</small>
          <div class='font-16 pointer-cursor'>
            {{place.numberOfSources}}

          </div>
        </div>
        <div class='col-6 col-md-4 col-xl-3'>

          <small>LAST TESTED</small>
          <div class='text-capitalize font-16 pointer-cursor'>

            {{place.lastTested}}
          </div>


        </div>
        <div class='col-12 col-xl-3' *ngIf='place.lat && place.lng'>
          <google-map
            height='150px'
            width='200px'
            [zoom]='15'
            [center]='{lat:place?.lat, lng: place?.lng}'>
            <map-marker
              #markerElem='mapMarker'
              [id]='place.place_id'
              [position]='{lat:place?.lat, lng: place?.lng}'
              [options]='markerOptions'>

            </map-marker>
          </google-map>

        </div>
      </div>

    </div>

  </div>
</div>
